export const DEFAULT_POLL_TIME = 60000;
export const MINIMUM_POLL_TIME = 30000;
export const TASK_DEFAULT_POLL_TIME = 60000;
export const TASK_MINIMUM_POLL_TIME = 30000;
// the Tasks app is only provisioned in this domain for now; hosts can override it with taskConfig.taskDomain
export const TASK_DEFAULT_DOMAIN = 'Shared Service Test Org';
export const FLAG_CACHE_EXPIRY_MINUTES = 5;
export const DEFAULT_SEARCH_LIMIT = 20;
export const APP_SWITCHER_LOCK_ICON_TEXT = 'Additional Solutions Require Authentication';
export const ORG_SWITCHER_LOCK_ICON_TEXT = 'Additional Organizations Require Authentication';

export const CONFIG_ERRORS = {
    REMOTE_CONFIG_LOAD_FAILED: 'Failed to load remote configuration, falling back to defaults:',
    ENDPOINT_REQUIRED: 'Endpoint is required to fetch sidekick configuration',
    CONFIG_FETCH_FAILED: 'Failed to fetch sidekick configuration:',
    INVALID_RESPONSE_TYPE: 'Invalid response: Expected JSON content type',
    INVALID_CONFIG_FORMAT: 'Invalid configuration: Response is not a valid object',
    CONFIG_PARSE_FAILED: 'Failed to fetch or parse sidekick configuration:'
};

export const SEARCH_ERRORS = {
    ENDPOINT_REQUIRED: 'Endpoint is required to fetch search results',
    SEARCH_FETCH_FAILED: 'Failed to fetch search results:',
    INVALID_SEARCH_RESPONSE_TYPE: 'Invalid search response: Expected JSON or text content type',
    SEARCH_PARSE_FAILED: 'Failed to fetch or parse search results:'
};

export const COMMON_ERRORS = {
    SOMETHING_WENT_WRONG: 'Something went wrong, please try again.'
};

export const CONFIG_BASE_DELAY = 500;

export const NOTIFICATION_SERVICE_ERRORS = {
    DEFAULT: 'Something went wrong while fetching your notifications. Please try again later.',
    NOT_ENABLED: 'Platform notifications are not enabled.',
    BASE_URL_NOT_SET: 'Notification base URL is not set. Please configure it.',
    FETCH_ERROR: 'Failed to fetch notifications',
    API_DOWN: 'Notification Service API is down. Please try again later.'
};

// Notifications panel subtitle; these strings are also translation tokens (util/translations.js)
export const NOTIFICATION_REVIEW_TEXT = {
    SINGULAR: 'update needs review',
    PLURAL: 'updates need review'
};

// Tasks panel subtitle; these strings are also translation tokens (util/translations.js)
export const TASK_ATTENTION_TEXT = {
    SINGULAR: 'item needs your attention',
    PLURAL: 'items need your attention'
};

export const STORE_KEY_MAP = {
	'aboveTheLineItems': 'nav',
    'quickLinkItems': 'quick-link-nav',
	'belowTheLineItems': 'below-line-nav',
	'search': 'search',
	'help-menu': 'help',
    'activity-indicator': 'activity-indicator',
    'current-org': 'current-org',
    'org-branding': 'org-branding-data'
};

export const FL_USER_SOURCE = {
    IDM: 'idm',
    PASSPORT: 'passport'
};

export const PENDO_CONFIG = {
    CDN_URL: 'https://us1.cdn.pendo.io/agent/static',
    IDLE_TIMEOUT: 500, // Default requestIdleCallback timeout in milliseconds
    DEFAULT_VISITOR_ID: 'anonymous',
    DEFAULT_ACCOUNT_ID: 'default'
};

export const CACHE_CONFIG = {
    DEFAULT_TTL: 30 * 60 * 1000, // Default: 30 minutes in milliseconds
    MAX_SIZE: 1024 * 1024, // 1MB limit
    CONFIG_PREFIX: 'SK_CONFIG_',
    FEATURE_FLAG_PREFIX: 'SK_FLAGS_',
    DEFAULT_STORAGE: 'local' // Default storage type: 'local' or 'session'
};

export const TASK_SERVICE_ERRORS = {
    DEFAULT: 'Something went wrong while fetching your tasks. Please try again later.',
};

export const TASK_API_ERRORS = {
    ENDPOINT_REQUIRED: 'Task API endpoint is not configured',
    TASK_NOT_FOUND: 'Task not found',
    PERMISSION_DENIED: 'You do not have permission to perform this action',
    FETCH_FAILED: 'Failed to fetch task data',
    INVALID_TASK_ID: 'Invalid task ID',
    API_DOWN: 'Task Service API is down. Please try again later.',
    CREATE_FAILED: 'Failed to create task',
    UPDATE_FAILED: 'Failed to update task',
    DELETE_FAILED: 'Failed to delete task',
};

